'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// import 'draft-js/dist/Draft.css'
// eslint-disable-next-line import/no-unresolved

// import { save } from 'redux/modules/saveUserData';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _reactDom = require('react-dom');

var _draftJs = require('draft-js');

var _templateData = require('redux/modules/templateData');

var templateData = _interopRequireWildcard(_templateData);

var _semanticUiReact = require('semantic-ui-react');

require('./ResumeAnalysis.css');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ESSENTIAL_SECTIONS = ['SUM', 'KS', 'PR', 'ED'];
var ESSENTIAL_SECTIONS_NAMES = ['Summary', 'Key Skills', 'Professional Experience', 'Education'];
var PAGE_1 = 1;
var PAGE_2 = 2;

var POSITIVE_ICON = 'POSITIVE_ICON';
var NEGATIVE_ICON = 'NEGATIVE_ICON';
var NEUTRAL_ICON = 'NEUTRAL_ICON';

var LESS_THAN_1 = 'LESS_THAN_1';
var BETWEEN_1_AND_2 = 'BETWEEN_1_AND_2';
var MORE_THAN_2 = 'MORE_THAN_2';

var ANALYSIS_RESULT_DICT = {
  "number_of_pages_check": {
    "BETWEEN_1_AND_2": {
      "text": "It seems your resume is between 1-2 pages. Ensure that you either\
                trim it down to one page (if you have less than 10 years of experience)\
                or extend it to complete two pages (10+ years experience). ",
      "style": "NEUTRAL_ICON"
    },
    "LESS_THAN_1": {
      "text": "Good job! Your resume is within one page. Ensure that you use the entire\
                page to add maximum possible information on your resume",
      "style": "POSITIVE_ICON"
    },
    "MORE_THAN_2": {
      "text": "Looks like your resume is more than 2 pages long. We highly recommend that\
                you trim it down to 2 pages",
      "style": "NEGATIVE_ICON"
    }
  }
};

var ResumeAnalysis = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    text_analysis_data: state.templateData.text_analysis_data,
    info_block: state.templateData.info_block,
    highlighted_action_verb: state.templateData.highlighted_action_verb
  };
}, {
  highlightActionVerb: templateData.highlightActionVerb
}), _dec(_class = function (_Component) {
  (0, _inherits3.default)(ResumeAnalysis, _Component);

  function ResumeAnalysis(props) {
    (0, _classCallCheck3.default)(this, ResumeAnalysis);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ResumeAnalysis.__proto__ || (0, _getPrototypeOf2.default)(ResumeAnalysis)).call(this, props));

    _this.state = {
      resumeAnalysisVisible: false,
      resume_analysis_object: false
    };

    _this.calculatePages = function () {
      var cv = document.querySelectorAll('.cv')[0];
      var cvHeight = cv.offsetHeight * 0.264583 / 297;
      return cvHeight;
    };

    _this.doResumeAnalysis = function () {
      var number_of_pages = _this.calculatePages();

      var number_of_pages_check = void 0;
      if (number_of_pages > PAGE_1 && number_of_pages < PAGE_2) {
        number_of_pages_check = BETWEEN_1_AND_2;
      } else if (number_of_pages < PAGE_1) {
        number_of_pages_check = LESS_THAN_1;
      } else {
        number_of_pages_check = MORE_THAN_2;
      }

      var essential_sections_check = ESSENTIAL_SECTIONS.map(function (section, index) {
        if (_this.props.info_block.hasOwnProperty(section)) {
          if (_this.props.info_block[section].length < 1) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      });

      _this.setState({ resume_analysis_object: {
          essential_sections_check: essential_sections_check,
          number_of_pages_check: number_of_pages_check
        },
        resumeAnalysisVisible: true
      });
    };

    _this.closeSectionAnalysis = function () {
      _this.setState({ resumeAnalysisVisible: false });
    };

    return _this;
  }

  (0, _createClass3.default)(ResumeAnalysis, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          resumeAnalysisVisible = _state.resumeAnalysisVisible,
          resume_analysis_object = _state.resume_analysis_object;


      return _react2.default.createElement(
        'div',
        { className: 'resumeAnalysisBox' },
        _react2.default.createElement(_semanticUiReact.Icon, { color: 'blue', onClick: function onClick(e) {
            return _this2.doResumeAnalysis();
          }, style: { position: 'absolute', top: '100px', fontSize: '18px', left: 'calc(50% - 11.2cm)' }, name: 'file alternate' }),
        resumeAnalysisVisible && _react2.default.createElement(SectionAnalysisTextBox, {
          resume_analysis_object: resume_analysis_object,
          closeSectionAnalysis: this.closeSectionAnalysis
        })
      );
    }
  }]);
  return ResumeAnalysis;
}(_react.Component)) || _class);
exports.default = ResumeAnalysis;

var SectionAnalysisTextBox = function (_Component2) {
  (0, _inherits3.default)(SectionAnalysisTextBox, _Component2);

  function SectionAnalysisTextBox(props) {
    (0, _classCallCheck3.default)(this, SectionAnalysisTextBox);

    var _this3 = (0, _possibleConstructorReturn3.default)(this, (SectionAnalysisTextBox.__proto__ || (0, _getPrototypeOf2.default)(SectionAnalysisTextBox)).call(this, props));

    _this3.hasSomeParentTheClass = function (element, classname) {
      if (element.className) {
        if (element.className.split(' ').indexOf(classname) >= 0) return true;
      }
      return element.parentNode && _this3.hasSomeParentTheClass(element.parentNode, classname);
    };

    _this3.closeTextAnalysis = function (e) {

      if (_this3.hasSomeParentTheClass(e.target, 'textAnalysisWrapper') || _this3.hasSomeParentTheClass(e.target, 'sectionAnalysis') || _this3.hasSomeParentTheClass(e.target, 'subSectionAnalysis') || _this3.hasSomeParentTheClass(e.target, 'resumeAnalysisBox')) {
        _this3.props.closeSectionAnalysis();
      }
    };

    return _this3;
  }

  (0, _createClass3.default)(SectionAnalysisTextBox, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.addEventListener('click', this.closeTextAnalysis, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.closeTextAnalysis, false);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var resume_analysis_object = this.props.resume_analysis_object;


      var style_dict = {
        "POSITIVE_ICON": { color: 'green', icon: 'checkmark' },
        "NEGATIVE_ICON": { color: 'red', icon: 'close' },
        "NEUTRAL_ICON": { color: 'orange', icon: 'exclamation circle' }
      };

      var number_of_pages_check_val = resume_analysis_object['number_of_pages_check'];
      var essential_sections_check_val = resume_analysis_object['essential_sections_check'];

      var pages_check_text = ANALYSIS_RESULT_DICT["number_of_pages_check"][number_of_pages_check_val]['text'];
      var pages_check_style_tag = ANALYSIS_RESULT_DICT["number_of_pages_check"][number_of_pages_check_val]['style'];
      var pages_check_style = style_dict[pages_check_style_tag];

      return _react2.default.createElement(
        _semanticUiReact.Card,
        { className: 'textanalysis-card' },
        _react2.default.createElement(
          _semanticUiReact.Card.Content,
          null,
          _react2.default.createElement(
            _semanticUiReact.Card.Header,
            null,
            _react2.default.createElement(
              'div',
              null,
              ' Resume Analysis'
            ),
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'close', style: { cursor: 'pointer' }, color: 'black', onClick: function onClick(e) {
                return _this4.props.closeSectionAnalysis();
              } })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Card.Content,
          { style: { padding: '5px', maxHeight: '300px', overflow: 'auto', scrollBehavior: 'auto' } },
          _react2.default.createElement(
            _semanticUiReact.Feed,
            { className: 'textAnalysis-feed', size: 'small', style: { fontSize: '10px' } },
            _react2.default.createElement(
              _semanticUiReact.Feed.Event,
              null,
              _react2.default.createElement(_semanticUiReact.Feed.Label, { icon: pages_check_style.icon, style: { color: pages_check_style.color } }),
              _react2.default.createElement(
                _semanticUiReact.Feed.Content,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Feed.Summary,
                  null,
                  pages_check_text
                )
              )
            ),
            essential_sections_check_val.map(function (boolean_val, index) {
              var point_text = boolean_val ? 'Good job on adding the ' + ESSENTIAL_SECTIONS_NAMES[index] + '                               section in your resume' : 'Looks like you have not added the ' + ESSENTIAL_SECTIONS_NAMES[index] + '                               section in your resume. Consider adding it';
              var style = boolean_val ? style_dict[POSITIVE_ICON] : style_dict[NEGATIVE_ICON];
              return _react2.default.createElement(
                _semanticUiReact.Feed.Event,
                null,
                _react2.default.createElement(_semanticUiReact.Feed.Label, { icon: style.icon, style: { color: style.color } }),
                _react2.default.createElement(
                  _semanticUiReact.Feed.Content,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Feed.Summary,
                    null,
                    point_text
                  )
                )
              );
            })
          )
        )
      );
    }
  }]);
  return SectionAnalysisTextBox;
}(_react.Component);

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ResumeAnalysis/ResumeAnalysis.js
// module id = 1741
// module chunks = 0